import { SagaIterator } from "redux-saga";
import { select } from "redux-saga/effects";

import { ReportType } from "constants/reports/report-type";
import { ApiManager } from "services/api";
import { selectFeatureTogglePerformanceReport } from "store/entities/license";
import { Plan, selectCurrentSubscriptionPlan } from "store/entities/subscriptions";
import { IActionWithPayload } from "store/helper";

import { IFetchReportPayload } from "../interfaces";

import { makeFetchingSaga } from "./helpers";

export function* fetchTicketResolutionTime(action: IActionWithPayload<string, IFetchReportPayload>): SagaIterator {
  const isTeam = yield select(state => selectCurrentSubscriptionPlan(state) === Plan.Team);
  const hasPerformanceReport = yield select(selectFeatureTogglePerformanceReport);
  const requests = [
    {
      name: "ticketResolutionTime",
      interface: ApiManager.reportApi.fetchTicketResolutionTime,
    },
  ];
  if (hasPerformanceReport) {
    requests.push({
      name: "ticketResolutionTimePerTeam",
      interface: ApiManager.reportApi.fetchTicketResolutionTimePerTeam,
    });
    if (!isTeam) {
      requests.push({
        name: "ticketResolutionTimePerAgent",
        interface: ApiManager.reportApi.fetchTicketResolutionTimePerAgent,
      });
    }
  }

  // @ts-expect-error TS(2345): Argument of type '{ name: string; interface: any; ... Remove this comment to see the full error message
  yield makeFetchingSaga(ReportType.TicketResolutionTime, action, requests);
}
